/**
 * Флаги для функций, сделанных под конкретный прототип/демонстрацию (сейчас —
 * тендер по наружному освещению на тестовых данных МРСК), а не как часть основного
 * продукта. Каждую можно выключить одной строкой здесь, не выпиливая код физически,
 * пока не станет ясно, остаётся фича в продукте или это было разовое демо.
 *
 * Это НЕ то же самое, что настройки карты (AdminDataContext -> mapSettings.tools) —
 * те живут в БД, управляются админом через интерфейс и касаются готовых, стабильных
 * инструментов. Флаги здесь — код-левел рубильник для прототипного функционала,
 * трогать их можно только редактированием этого файла и пересборкой.
 *
 * Когда фича из прототипа становится частью продукта — просто удали её флаг отсюда
 * и все проверки `featureFlags.xxx &&` в местах, где он использовался.
 */
export const featureFlags = {
  /** Объектный калькулятор на карте (не путать с калькулятором внутри карточки
   * объекта — тот часть продукта, не прототип): клик по объектам одного типа
   * накапливает выборку и суммирует длину/площадь.
   * Где используется: MapControls.tsx (кнопка на панели инструментов),
   * MapContext.tsx (startObjectCalc/stopObjectCalc/clearObjectCalc и обработчик
   * клика), ObjectCalculatorPanel.tsx (панель результатов). */
  objectCalculatorOnMap: true,

  /** Раздел «Отчёты»: экспорт объектов любого слоя в Excel, отчёты по показаниям
   * электроэнергии (план/факт, по периодам, потребление) и сводный отчёт с
   * группировкой по полю слоя (например, по балансодержателю). Бэкенд-часть —
   * см. app/feature_flags.py (EXCEL_EXPORT/ENERGY_REPORTS/GROUP_BY_REPORT) в
   * maps-service — это два независимых рубильника, фронтенд ничего не покажет
   * даже если бэкенд не выключен, и наоборот бэкенд вернёт 404, даже если
   * фронтенд включён.
   * Где используется: ReportsPage.tsx, App.tsx (маршрут), PrimaryNavRail (пункт меню). */
  reportsPrototype: true,

  /** Иерархическая привязка объектов (родитель/дочерние) на карточке объекта —
   * пункты 1-3 чек-листа демонстрации (структура объектов наружного освещения,
   * устройство управления линией, привязка прибора учёта к нему). Бэкенд-часть —
   * см. app/feature_flags.py (OBJECT_HIERARCHY) в maps-service, независимый
   * рубильник: фронтенд ничего не покажет даже если бэкенд включён, и наоборот.
   * Где используется: ObjectCardBody.tsx (секция «Родительский объект» / «Дочерние объекты»). */
  objectHierarchy: true,
} as const;
